import { IEirSalesSavePrequalPayload } from "@modules/eirSalesFacade/interfaces/payloads/IEirSalesSavePrequalPayload";
import { IAddress } from "@interface/customerDetails/IAddress";
import { getAcquisitionType } from "@utils/acquisitionTypeUtils";

export const mapEirSalesSavePrequalPayload = (address: IAddress): IEirSalesSavePrequalPayload => ({
    address: {
        eirCode: address.eircode as string,
        county: address.county,
        town: address.town,
        addressLine1: address.addressLine1,
        addressLine2: address.addressLine2,
        addressLine3: address.addressLine3,
    },
    acquisitionType: getAcquisitionType(),
});
